/**
 * Shared base64 ↔ ArrayBuffer conversion utilities.
 * Consolidated from encryption.ts, file-encryption.ts, double-ratchet.ts, useEncryptedChat.ts
 * to eliminate code duplication (Audit Finding #5).
 */

/** Convert ArrayBuffer to base64 string */
export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

/** Convert base64 string to ArrayBuffer */
export function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}

/** Alias: ab2b64 */
export const ab2b64 = arrayBufferToBase64;

/** Alias: b642ab */
export const b642ab = base64ToArrayBuffer;
